var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 84,
    viewBox: "0 0 96 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.604 80C43.35 77.181 16.442 58.824 7.92 39.827c-1.72-3.404-2.588-7.026-2.588-10.805 0-13.06 10.49-23.689 23.38-23.689 4.47 0 8.804 1.287 12.56 3.732l-4.818 4.276 3.494 3.731-16.531 14.517 23.937 2.22C43.612 38.751 36.993 47.5 36.993 47.5l16.578 2.56-3.286 5.352c-2.58 4.208-5.255 8.559-5.437 8.872l-.329.545 13.629-.66L47.604 80z",
    fill: "url(#svewpasx0a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m62.18 62.01-12.251-.163 3.985-5.563c2.93-4.085 5.954-8.313 6.162-8.6l.296-.394-12.654-3.63 12.795-15.265-17.103-2.6 9.67-7.327.276-.211-3.743-4.685C54.068 8.336 60.5 5.347 67.287 5.347c12.896 0 23.38 10.629 23.38 23.688 0 3.772-.867 7.402-2.58 10.786-7.978 17.791-32.332 35.188-38.723 39.532l12.809-17.335.007-.007z",
    fill: "url(#015m2ovc0b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "svewpasx0a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 63.3333 -92.7413 0 31.74 18.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "015m2ovc0b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 62.7731 -82.9822 0 67.038 18.562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeIcon);
export default __webpack_public_path__ + "static/media/dislike_icon.2c61bd310c1c9ca338cca5d5d2be8305.svg";
export { ForwardRef as ReactComponent };